export const getHeight = (length: number) => {
	return 60 + 40 + length * 50 + (length - 1) * 10;
};
